// extracted by mini-css-extract-plugin
module.exports = {"container":"SidePanel_container__1K6MR","content":"SidePanel_content__3m7Rx","collapseToggle":"SidePanel_collapseToggle__9dy_f","activeNavLink":"SidePanel_activeNavLink__2PsDn"};